import '../../typings/moment/moment.js';
import {SensorChartRenderContext} from './SensorChartRenderContext';
import {IRenderer, Renderer} from '../../Renderer';
import {IChartOptions} from '../../ChartOptions';
import {TextUtils} from '../../Utils';
import {NumericAxis} from '../../Axis';
import * as moment from 'moment';

	export class SensorChartRenderer extends Renderer implements IRenderer<SensorChartRenderContext> {

		private static NUMBER_FORMAT="0.#####";

		public render(context: SensorChartRenderContext, options: IChartOptions){
			super.render(context, options);
			this.renderLabels(context, options);
		}



		public renderLabels(context: SensorChartRenderContext, options: IChartOptions) {
			var ctx = context.getContext('labels');
			ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

			var xAxis = context.axesConfiguration.xAxes[0];
			var yAxis = context.axesConfiguration.yAxes[0];
			var xMin = xAxis.minimum;
			var xMax =  xAxis.maximum;
			var yMin = yAxis.minimum;
			var yMax = yAxis.maximum;

			var unitOfMeasure = (yAxis instanceof NumericAxis)? yAxis.unitOfMeasure : "";

			var layout = context.getComponentLayout();

			//show limits in corners

			//top
			var TOP  = {
				top: layout.labels.top.top,
				left: layout.labels.top.left,
				width: layout.labels.top.width,
				height: layout.labels.top.height,
				right: layout.labels.top.left + layout.labels.top.width,
				bottom: layout.labels.top.top + layout.labels.top.height,
				vCenter: layout.labels.top.top + layout.labels.top.height / 2,
				hCenter: layout.labels.top.left + layout.labels.top.width / 2
			};

			var BOTTOM = {
				top: layout.labels.bottom.top,
				left: layout.labels.bottom.left,
				width: layout.labels.bottom.width,
				height: layout.labels.bottom.height,
				right: layout.labels.bottom.left + layout.labels.bottom.width,
				bottom: layout.labels.bottom.top + layout.labels.bottom.height,
				vCenter: layout.labels.bottom.top + layout.labels.bottom.height / 2,
				hCenter: layout.labels.bottom.left + layout.labels.bottom.width / 2
			};

			ctx.fillStyle = options.labelBackground;
			ctx.fillRect(TOP.left, TOP.top, TOP.width, TOP.height);
			ctx.fillRect(BOTTOM.left, BOTTOM.top, BOTTOM.width, BOTTOM.height);
			ctx.fillStyle = options.labelForeground;
			ctx.font= options.fontSize + "px " + options.fontFace;

			var padding = 5;
			var textOffset = 0;
			if(isFinite(yMin)
					&& isFinite(yMax)) {

				/*var boundsMin = TextUtils.getTextBounds(format(SensorChartRenderer.NUMBER_FORMAT,yMin)
					    + ' ' + unitOfMeasure, 	options.fontSize, options.fontFace, false);
				var boundsMax = TextUtils.getTextBounds(format(SensorChartRenderer.NUMBER_FORMAT,yMax)
						+ ' ' + unitOfMeasure,  options.fontSize, options.fontFace, false);

				ctx.fillText(format(SensorChartRenderer.NUMBER_FORMAT,yMax) + ' ' +  unitOfMeasure,
						TOP.left + padding, TOP.vCenter + boundsMax.height / 2);

				ctx.fillText(format(SensorChartRenderer.NUMBER_FORMAT,yMax) + ' ' + unitOfMeasure,
						TOP.right - padding - boundsMax.width, TOP.vCenter + boundsMax.height / 2);

				ctx.fillText(format(SensorChartRenderer.NUMBER_FORMAT,yMin) + ' ' + unitOfMeasure,
						TOP.left + padding, BOTTOM.vCenter + boundsMin.height / 2);

				ctx.fillText(format(SensorChartRenderer.NUMBER_FORMAT,yMin) + ' ' + unitOfMeasure,
						BOTTOM.right - padding - boundsMin.width, BOTTOM.vCenter + boundsMin.height / 2);

				//calculate text offset for alignment
				textOffset = padding + Math.max(boundsMin.width, boundsMax.width) + padding*2;
*/			}

			//render timeline
			var dateStart = moment(xMin).format(options.format.dateFormat);
			var timeStart = moment(xMin).format(options.format.timeFormat);
			var timeEnd = moment(xMax).format(options.format.timeFormat);
			var timeMed = moment(xMin + (xMax - xMin) / 2).format(options.format.timeFormat);

			var timeTextBounds = TextUtils.getTextBounds(timeMed,
					options.fontSize, options.fontFace, false);

			var halfTextHeight = timeTextBounds.height/2;

			ctx.fillText(dateStart, BOTTOM.left + textOffset, TOP.vCenter + halfTextHeight);
			ctx.fillText(timeStart, BOTTOM.left + textOffset, BOTTOM.vCenter + halfTextHeight);
			ctx.fillText(timeMed, BOTTOM.hCenter - timeTextBounds.width/2, BOTTOM.vCenter + halfTextHeight);
			ctx.fillText(timeEnd, BOTTOM.right - textOffset - timeTextBounds.width, BOTTOM.vCenter + halfTextHeight);

		}

		public renderZoneMarkers_Debug(context: SensorChartRenderContext, options: IChartOptions) {

			var ctx = context.getContext('guides');
			ctx.globalAlpha = 0.5;

			var layout = context.getComponentLayout();
			//plot
			var top = layout.plot.top;
			var left = layout.plot.left;
			var width = layout.plot.width;
			var height = layout.plot.height;

			ctx.strokeStyle = 'blue';
			ctx.strokeRect(left, top, width, height);

			//labels top
			var top = layout.labels.top.top;
			var left = layout.labels.top.left;
			var width = layout.labels.top.width;
			var height = layout.labels.top.height;
			ctx.strokeStyle = 'green';
			ctx.strokeRect(left, top, width, height);

			//labels bottom
			var top = layout.labels.bottom.top;
			var left = layout.labels.bottom.left;
			var width = layout.labels.bottom.width;
			var height = layout.labels.bottom.height;
			ctx.strokeStyle = 'green';
			ctx.strokeRect(left, top, width, height);

			ctx.globalAlpha = 1;

		}

	}

